import React, { useEffect, useState, useMemo } from "react";
import "./animation.css";

const SkillsComponent = () => {
  const [progress, setProgress] = useState({});

  const skills = useMemo(
    () => [
      { name: "HTML", level: 90 },
      { name: "CSS/Tailwind", level: 80 },
      { name: "JavaScript", level: 75 },
      { name: "React", level: 80 },
      { name: "Node.js", level: 75 },
      { name: "Next.js", level: 70 },
    ],
    []
  );
  useEffect(() => {
    const calculateProgress = () => {
      const updatedProgress = {};
      skills.forEach((skill) => {
        updatedProgress[skill.name] = skill.level;
      });
      setProgress(updatedProgress);
    };

    calculateProgress();
  }, [skills]);

  useEffect(() => {
    const progressBarObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelector(".progress-bar-inner").style.width = `${
              progress[entry.target.id]
            }%`;
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    const skillBars = document.querySelectorAll(".skill");

    skillBars.forEach((skillBar) => {
      progressBarObserver.observe(skillBar);
    });

    return () => progressBarObserver.disconnect();
  }, [progress]);

  return (
    <div className="skill-container">
      <h4>Development Skills</h4>
      <div className="skills-container">
        {Object.keys(progress).map((skillName) => (
          <div className="skill" id={skillName} key={skillName}>
            <div className="skill-name">{skillName}</div>
            <div className="progress-bar">
              <div className="progress-bar-inner">{progress[skillName]}%</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillsComponent;
